import React from 'react';

type UncollectibleProps = {
  width?: number;
  height?: number;
};

const Uncollectible = ({ width = 32, height = 32 }: UncollectibleProps) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='12' cy='12' r='12' fill='#EF5251' />
      <g clip-path='url(#clip0_3681_9735)'>
        <path
          d='M10.545 10.5C10.6626 10.1658 10.8946 9.88405 11.2 9.70457C11.5054 9.52508 11.8644 9.45947 12.2136 9.51936C12.5627 9.57924 12.8794 9.76076 13.1075 10.0318C13.3357 10.3028 13.4605 10.6458 13.46 11C13.46 12 11.96 12.5 11.96 12.5M12 14.5H12.005M17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12Z'
          stroke='white'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_3681_9735'>
          <rect
            width='12'
            height='12'
            fill='white'
            transform='translate(6 6)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Uncollectible;
